import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import SignalmentSwitcher from './../../components/SignalmentSwitcher/SignalmentSwitcher';
import * as actionTypes from './../../store/actions/signalmentAction';
import fetchSignalmentAction from './../../store/actions/fetch/fetchSignalmentAction';
import * as genderValues from './../Gender/GenderValues';
import Loader from './../../components/Loader/Loader'

/**
 * Signalment container
 */
class Signalment extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  greyed() {
    const {selectedSterilised, selectedPregnant, selectedLactation,
      selectedGender, onSelectSterilised, onSelectPregnant,
      onSelectLactation, lifeStage} = this.props;
    // Default is not greyed
    let greyedSterilised = false;
    let greyedPregnant = false;
    let greyedLactation = false;

    // Rules
    if(selectedGender === genderValues.MALE || lifeStage == "nursing"){
      greyedPregnant = true;
      greyedLactation = true;
    }
    if(selectedSterilised){
      greyedPregnant = true;
    }
    if(selectedPregnant){
      greyedLactation = true;
    }
    if(selectedLactation){
      greyedPregnant = true;
    }
    if(selectedPregnant){
      greyedSterilised = true;
    }

    // Set values accordingly to greyed fields
    if(selectedSterilised && greyedSterilised){
      onSelectSterilised(false);
    }
    if(selectedPregnant && greyedPregnant){
      onSelectPregnant(false);
    }
    if(selectedLactation && greyedLactation){
      onSelectLactation(false);
    }

    // Return values for rendering
    return {
      greyedSterilised: greyedSterilised,
      greyedPregnant: greyedPregnant,
      greyedLactation: greyedLactation
    }
  }

  render() {
    const {data, error, pending, selectedSterilised, selectedPregnant,
      selectedLactation, onSelectSterilised, onSelectPregnant,
      onSelectLactation, defaultValues, ready} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Get greyed values
    const {greyedSterilised, greyedPregnant, greyedLactation} = this.greyed();
    // Return switcher
    return (
      <div className='nppe2-fc-signalment-switcher__wrapper'>
        {error && <span className='nppe2-fc-signalment__error'>{error}</span>}
        {!error &&
        <SignalmentSwitcher
          data={data}
          selectedSterilised={selectedSterilised}
          selectedPregnant={selectedPregnant}
          selectedLactation={selectedLactation}
          onSelectSterilised={onSelectSterilised}
          onSelectPregnant={onSelectPregnant}
          onSelectLactation={onSelectLactation}
          greyedSterilised={greyedSterilised}
          greyedPregnant={greyedPregnant}
          greyedLactation={greyedLactation}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedSterilised: state.signalmentReducer.selectedSterilised,
    selectedPregnant: state.signalmentReducer.selectedPregnant,
    selectedLactation: state.signalmentReducer.selectedLactation,
    selectedGender: state.genderReducer.selected,
    error: state.signalmentReducer.error,
    data: state.signalmentReducer.data,
    pending: state.signalmentReducer.pending,
    ready: state.signalmentReducer.ready,
    lifeStage: state.calculateDerReducer.data.lifeStage,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchSignalmentAction
      },
      dispatch,
    ),
    onSelectSterilised: (value) => dispatch({
      type: actionTypes.SELECT_STERILISED,
      selectedSterilised: value,
    }),
    onSelectPregnant: (value) => dispatch({
      type: actionTypes.SELECT_PREGNANT,
      selectedPregnant: value,
    }),
    onSelectLactation: (value) => dispatch({
      type: actionTypes.SELECT_LACTATION,
      selectedLactation: value,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Signalment);
